import { Accordion } from "../components/blocks/accordion";

const test = ({ __typename }: { __typename: string }): boolean => {
  return __typename === "VinoData_Accordion";
};

const create = (data: any): JSX.Element => {
  const { collections } = data;
  const transformedData = {
    ...data,
    collections: collections.map((collection) => ({
      ...collection,
      header: collection.internalName,
      bodyText: { json: JSON.parse(collection.textBody.json.raw) },
    })),
  };

  return <Accordion {...transformedData} />;
};

export default { test, create };
